"use strict";

/**
 * Sequence logo component.
 * Inspired / derived from https://github.com/weng-lab/logojs-package
 *  (but simpler)
 */
var _slicedToArray = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
require("./SequenceLogo.scss");
var SequenceLogoGlyphs_1 = require("../common/SequenceLogoGlyphs");
var MolecularStyles_1 = require("../common/MolecularStyles");
var react_tooltip_1 = __importDefault(require("react-tooltip"));
var Residues_1 = require("../common/Residues");
var LOGO_TYPES;
(function (LOGO_TYPES) {
  LOGO_TYPES["LETTERS"] = "Letter Stack";
  LOGO_TYPES["BARS"] = "Bar Plot";
})(LOGO_TYPES = exports.LOGO_TYPES || (exports.LOGO_TYPES = {}));
var SequenceLogoComponent = /*#__PURE__*/function (_react_1$default$Comp) {
  _inherits(SequenceLogoComponent, _react_1$default$Comp);
  function SequenceLogoComponent() {
    _classCallCheck(this, SequenceLogoComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(SequenceLogoComponent).apply(this, arguments));
  }
  _createClass(SequenceLogoComponent, [{
    key: "renderTooltip",
    /*
     *
     *
     * PRIVATE METHODS
     *
     *
     */
    value: function renderTooltip() {
      var _this = this;
      var tooltipPlacement = this.props.tooltipPlacement;
      return react_1.default.createElement(react_tooltip_1.default, {
        id: "getLogoTooltip",
        effect: "solid",
        type: "light",
        place: tooltipPlacement,
        border: true,
        getContent: function getContent(pos) {
          if (!pos || !_this.logoData || !_this.logoData[parseInt(pos)]) {
            return;
          }
          var position = parseInt(pos) + 1;
          var glyphData = _this.logoData[parseInt(pos)];
          return glyphData.length === 0 ? null : react_1.default.createElement("div", {
            className: "logo-tooltip"
          }, react_1.default.createElement("h1", null, "Position: ", position), react_1.default.createElement("div", {
            className: "row"
          }, react_1.default.createElement("div", {
            className: "col legend-square"
          }), react_1.default.createElement("div", {
            className: "col header name"
          }, "Residue"), react_1.default.createElement("div", {
            className: "col header frequency"
          }, "Frequency"), react_1.default.createElement("div", {
            className: "col header count"
          }, "Count")), glyphData.slice().reverse().map(function (letterFreq, myidx) {
            return react_1.default.createElement("div", {
              key: myidx,
              className: "row"
            }, react_1.default.createElement("div", {
              className: "col legend-square ".concat(letterFreq.letter.classNames)
            }), react_1.default.createElement("div", {
              className: "col name"
            }, "".concat(letterFreq.residue.fullName, " [").concat(letterFreq.letter.letter, "]")), react_1.default.createElement("div", {
              className: "col frequency"
            }, +(letterFreq.frequency * 100).toFixed(2), "%"), react_1.default.createElement("div", {
              className: "col count"
            }, letterFreq.count));
          }));
        }
      });
    }
    /**
     * Generate the svg elements for a single position, i.e., column
     */
  }, {
    key: "renderSinglePositionStack",
    value: function renderSinglePositionStack(positionalFrequencies, numGlyphStacks) {
      var logoType = this.props.logoType;
      var dy = 100;
      return positionalFrequencies.map(function (freq, idx) {
        dy = dy - freq.frequency * 100;
        if (logoType === LOGO_TYPES.BARS) {
          var _xscale = 2 / numGlyphStacks; // not exact, but works.
          return react_1.default.createElement("rect", {
            width: "100",
            height: "100",
            transform: "translate(0, ".concat(dy, ") scale(").concat(_xscale, ",").concat(freq.frequency, ")"),
            className: freq.letter.classNames,
            key: "idxrect_".concat(idx)
          });
        }
        var xscale = 0.009; // invariant scaling
        var selectedGlyph = SequenceLogoGlyphs_1.GlyphFactory.glyphFromChar(freq.letter.letter)({
          className: freq.letter.classNames,
          transform: "translate(0, ".concat(dy, ") scale(").concat(xscale, ",").concat(freq.frequency, ")"),
          key: "idxglyph_".concat(idx)
        });
        return selectedGlyph;
      });
    }
    /**
     * Munge letter count data that was calculated during alignment creation
     * into a form appropriate for the glyph generation
     */
  }, {
    key: "mungeLogoData",
    value: function mungeLogoData() {
      var alignment = this.props.alignment;
      var numberSequences = alignment.getSequences().length;
      var lettersSorted = alignment.getAllUpperAlphaLettersInAlignmentSorted();
      var alignmentType = this.props.alignmentType ? this.props.alignmentType : this.props.alignment.getPredictedType();
      var moleculeClass = alignmentType === MolecularStyles_1.AlignmentTypes.AMINOACID ? Residues_1.AminoAcid : Residues_1.Nucleotide;
      //load class names for each letter
      var letterObjects = lettersSorted.reduce(function (arr, letter) {
        arr[letter] = {
          letter: letter,
          classNames: MolecularStyles_1.getLetterClassNames(letter, false, false, false)
        };
        return arr;
      }, {});
      //note: removes invalid letters, but letterCount (value) isn't sorted
      var plc = alignment.getPositionalLetterCounts(false, lettersSorted);
      return Array.from(plc).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          pos = _ref2[0],
          letterCounts = _ref2[1];
        return Object.entries(letterCounts).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            letter = _ref4[0],
            count = _ref4[1];
          return {
            count: count,
            frequency: count / numberSequences,
            letter: letterObjects[letter],
            residue: moleculeClass.fromSingleLetterCode(letter)
          };
        }).filter(function (freq) {
          // remove empty letters
          return freq.frequency !== 0;
        }).sort(function (a, b) {
          return a.frequency > b.frequency ? 1 : -1;
        });
      });
    }
    /*
     *
     *
     * REACT METHODS
     *
     *
     */
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
        alignment = _this$props.alignment,
        alignmentType = _this$props.alignmentType,
        logoType = _this$props.logoType,
        glyphWidth = _this$props.glyphWidth;
      if (!this.logoData || logoType !== nextProps.logoType || glyphWidth !== nextProps.glyphWidth || alignment !== nextProps.alignment || alignmentType !== nextProps.alignmentType) {
        return true;
      }
      return false;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      react_tooltip_1.default.rebuild();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        alignment = _this$props2.alignment,
        glyphWidth = _this$props2.glyphWidth,
        height = _this$props2.height;
      if (!alignment || !glyphWidth) {
        return null;
      }
      //perform a bunch of data munging
      this.logoData = this.mungeLogoData();
      var totalWidth = this.logoData.length * glyphWidth;
      return react_1.default.createElement("div", {
        className: "sequence-logo"
      }, react_1.default.createElement("svg", {
        preserveAspectRatio: "none",
        viewBox: "0 0 ".concat(this.logoData.length, " 100"),
        style: {
          width: totalWidth,
          height: height ? height : SequenceLogoComponent.defaultProps.height
        },
        xmlns: "http://www.w3.org/2000/svg"
      }, this.logoData.map(function (singlePositionData, positionIdx) {
        return react_1.default.createElement("g", {
          transform: "translate(".concat(positionIdx, ",0)"),
          className: MolecularStyles_1.aceResidueParentClass,
          key: "p_" + positionIdx
        }, _this2.renderSinglePositionStack(singlePositionData, _this2.logoData.length), react_1.default.createElement("rect", {
          className: "interaction-placeholder",
          width: "1",
          height: "100",
          "data-for": "getLogoTooltip",
          "data-tip": positionIdx,
          "data-class": "sequence-logo-tooltip-container"
        }));
      })), this.renderTooltip());
    }
  }]);
  return SequenceLogoComponent;
}(react_1.default.Component);
exports.SequenceLogoComponent = SequenceLogoComponent;
SequenceLogoComponent.defaultProps = {
  logoType: LOGO_TYPES.LETTERS,
  height: "100px"
};